import { workspacesClient, apiBaseUrl } from "../api/ApiClients";
import { axiosInstance } from "../api/AxiosInterceptor";
import {
  ISetWorkspaceColorCommand,
  IUpdateMealLoggingPromptsCommand,
  IUpdateWorkspaceCommand,
  SetWorkspaceColorCommand,
  UpdateMealLoggingPromptsCommand,
  UpdateWorkspaceCommand,
  ISetNutritionEnabledCommand,
  SetNutritionEnabledCommand,
  ISetMealLoggingsEnabledCommand,
  SetMealLoggingsEnabledCommand,
  ISubmitBrandedAppRequestCommand,
  SubmitBrandedAppRequestCommand,
  SetSuggestedAssetsEnabledCommand,
  ISetSuggestedAssetsEnabledCommand,
  ISetClientProfilePositionsCommand,
  SetClientProfilePositionsCommand,
  UpdateBrandedAppBannerCommand,
  IUpdateBrandedAppBannerCommand,
  IRequestBrandedAppCommand,
  RequestBrandedAppCommand,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class WorkspaceService extends ServiceBase {
  async getWorkspace(slug: string) {
    return workspacesClient.getWorkspace(slug);
  }

  async getWorkspaceClientPortal() {
    return workspacesClient.getWorkspaceClientPortal();
  }

  async getCoachWorkspaceTheme() {
    return workspacesClient.getCoachWorkspaceTheme();
  }

  async updateWorkspace(variables: IUpdateWorkspaceCommand) {
    const command = UpdateWorkspaceCommand.fromJS(variables);
    return workspacesClient.updateWorkspace(variables.id, command);
  }

  async updateCoachWorkspaceTheme(variables: ISetWorkspaceColorCommand) {
    const command = SetWorkspaceColorCommand.fromJS(variables);
    return workspacesClient.setWorkspaceColor(command.id, command);
  }

  async updateMealLoggingPrompts(variables: IUpdateMealLoggingPromptsCommand) {
    const command = UpdateMealLoggingPromptsCommand.fromJS(variables);
    return workspacesClient.updateMealLoggingPromts(command.id, command);
  }

  async setNutritionEnabled(variables: ISetNutritionEnabledCommand) {
    const command = SetNutritionEnabledCommand.fromJS(variables);
    return workspacesClient.setNutritionEnabled(command);
  }

  async setMealLogginsEnabled(variables: ISetMealLoggingsEnabledCommand) {
    const command = SetMealLoggingsEnabledCommand.fromJS(variables);
    return workspacesClient.setMealLoggingsEnabled(command);
  }

  async submitBrandedAppRequest(variables: ISubmitBrandedAppRequestCommand) {
    const command = SubmitBrandedAppRequestCommand.fromJS(variables);
    return workspacesClient.submitBrandedAppRequest(command);
  }

  async getBrandedAppManagerUsername() {
    return workspacesClient.getBrandedAppManagerUsername();
  }

  async setSuggestedAssetsEnabled(
    variables: ISetSuggestedAssetsEnabledCommand,
  ) {
    const command = SetSuggestedAssetsEnabledCommand.fromJS(variables);
    return workspacesClient.setSuggestedAssetsEnabled(command);
  }

  async setClientProfileCardsPositions(
    variables: ISetClientProfilePositionsCommand,
  ) {
    const command = SetClientProfilePositionsCommand.fromJS(variables);
    return workspacesClient.setClientProfilePositions(command);
  }
  async updateBrandedAppBanner(variables: IUpdateBrandedAppBannerCommand) {
    const command = UpdateBrandedAppBannerCommand.fromJS(variables);
    return workspacesClient.updateBrandedAppBanner(command);
  }

  async requestBrandedApp(variables: IRequestBrandedAppCommand) {
    const command = RequestBrandedAppCommand.fromJS(variables);
    return workspacesClient.requestBrandedApp(command);
  }
}

export default new WorkspaceService();
